import '../OrderCreate.scss'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Col, Row } from 'react-bootstrap'
import StepZilla from 'react-stepzilla'
import Alert from 'sweetalert-react'

import { parseDate } from 'react-day-picker/moment'
import moment from 'moment'

import Card from 'src/components/cards/Card'
import Placeholder from 'src/components/Placeholder/Placeholder'

import {
  selectCurrentCompany,
  selectCurrentModule,
  selectCurrentUser,
} from 'src/selectors/user.selector'

import {
  actionTypes as warehouseActionTypes,
  getInventory,
  getInventoryWithPrices,
  getWarehouses,
  getWarehousesUser,
  setInventoryList,
  setOrigin,
} from 'src/actions/warehouse.actions'

import {
  actionTypes as typsC,
  getAllClients,
  getAllDeliverers,
  getClientsSimple,
} from 'src/actions/clients.actions'

import { getCompanyField } from 'src/actions/company.actions'

import {
  actionTypes,
  getSingleOrder,
  setInformationOrder,
} from 'src/actions/orders.actions'
import { selectGetSingleOrder } from 'src/selectors/orders.selector'

import { loadingSelector } from 'src/selectors/loading.selector'
import { hasErrorsSelector, singleErrorSelector } from 'src/selectors/error.selector'

import OrderSelectClient from './OrderSelectClient'
import OrderSelectProduct from './OrderSelectProducts'
import OrderResume from './OrderResume'

import {
  selectAllWarehousesForSelect,
  selectInventoryWithPrices,
} from 'src/selectors/warehouse.selector'
import {
  actionTypes as moduleTypes,
  getCurrentUserRolesAction,
} from 'src/actions/modules.actions'
import { getPermission, isAllowed } from 'src/selectors/modules.selector'

import { selectSetCurrentCompany } from 'src/selectors/company.selector'
import { selectAllClients, simpleClients } from 'src/selectors/clients.selector'

import { getPaymentMethods } from 'src/actions/utilities.actions'
import { clientPermissions } from 'src/enums/permissions'

class OrderCreate extends Component {
  state = {
    steps: [],
    alert: {
      show: false,
      title: 'default',
      text: 'default',
      type: 'info',
      onConfirm: () => console.log('default'),
    },
    warehouseAdmin: false,
  }

  componentDidMount() {
    const {
      getPaymentMethods,
      getCompanyField,
      getCurrentRoles,
      match,
      getOrder,
      module,
      setInfo,
      getWarehouses,
      setInventoryList,
      getDeliverers,
      setOrigin,
    } = this.props
    setInventoryList([])
    getPaymentMethods()
    getWarehouses(module === 15000)
    getDeliverers()
    setOrigin(2)
    if (module === 2000) getCompanyField(81)

    const { id } = match.params
    if (id) {
      getOrder(id)
    } else {
      getCurrentRoles(module)
      setInfo({
        deliveryDate: '',
        client: { label: '- No seleccionado -', value: null },
        products: [],
        paymentType: { label: '- No seleccionado -', value: null },
        warehouse: { label: '- No seleccionado -', value: null },
        presale: false,
      })

      let discountLimit = false
      if (module === 1000) discountLimit = true

      const steps = [
        {
          name: 'Seleccionar Cliente',
          component: (
            <OrderSelectClient
              {...this.props}
              isRequiredClient={true}
              discountLimit={discountLimit}
            />
          ),
        },
        {
          name: 'Seleccionar Producto',
          component: <OrderSelectProduct {...this.props} discountLimit={discountLimit} />,
        },
        { name: 'Resumen', component: <OrderResume {...this.props} /> },
      ]
      this.setState({ steps })
    }
  }

  UNSAFE_componentWillReceiveProps(next) {
    const { loading, hasError, setInfo, module, match, getInventoryWithPrices } =
      this.props
    const { params } = match
    const { error, order } = next
    if (loading && !next.loading) {
      if (!hasError && next.hasError) {
        console.log(error)
      } else {
        const { type } = order
        let steps = []
        let discountLimit = false
        if (module === 1000) discountLimit = true

        switch (type) {
          case 1:
            if (params.sale == undefined) {
              this.props.getAllClients()
              steps = [
                {
                  name: 'Seleccionar Cliente',
                  component: (
                    <OrderSelectClient {...this.props} isRequiredClient={true} />
                  ),
                },
                {
                  name: 'Seleccionar Producto',
                  component: (
                    <OrderSelectProduct {...this.props} discountLimit={discountLimit} />
                  ),
                },
                { name: 'Resumen', component: <OrderResume {...this.props} /> },
              ]
            } else {
              steps = [
                {
                  name: 'Seleccionar Producto',
                  component: (
                    <OrderSelectProduct {...this.props} discountLimit={discountLimit} />
                  ),
                },
                { name: 'Resumen', component: <OrderResume {...this.props} /> },
              ]

              let deliveryDate = order.enabledAt
              if (!deliveryDate) deliveryDate = parseDate(moment())
              else deliveryDate = parseDate(moment(deliveryDate))

              let warehouse = { label: '- No seleccionado -', value: null }

              if (order.warehouse) {
                warehouse.label = order.warehouse.name
                warehouse.value = order.warehouse.id
              }

              const item = Object.assign(
                {},
                {
                  ...order,
                  id: params.id,
                  client: {
                    ...order.client,
                    value: order.client.id,
                    label: order.client.companyName,
                  },
                  deliveryDate,
                  warehouse: warehouse,
                  products: [],
                  presale: false,
                  paymentType: {
                    ...order.paymentTypeData,
                    value: order.paymentTypeData.id,
                    label: order.paymentTypeData.name,
                  },
                },
              )
              setInfo(item)
              getInventoryWithPrices(warehouse.value, order.client, false)
            }
            break
          case 2:
            const { id } = this.props.match.params
            let deliveryDate = order.enabledAt

            if (!deliveryDate) deliveryDate = parseDate(moment())
            else deliveryDate = parseDate(moment(deliveryDate))

            console.log(order)

            const item = Object.assign(
              {},
              {
                ...order,
                id,
                client: {
                  ...order.client,
                  value: order.client.id,
                  label: order.client.companyName,
                },
                deliveryDate,
                warehouse: { label: '- No seleccionado -', value: null },
                products: [],
                presale: false,
              },
            )
            setInfo(item)
            steps = [
              {
                name: 'Seleccionar Cliente',
                component: <OrderSelectClient {...this.props} isRequiredClient={false} />,
              },
              {
                name: 'Seleccionar Producto',
                component: (
                  <OrderSelectProduct {...this.props} discountLimit={discountLimit} />
                ),
              },
              { name: 'Resumen', component: <OrderResume {...this.props} /> },
            ]
            break
        }

        this.setState({ steps })
      }
    }

    const { loadingWarehouses, user, discountLimit } = this.props
    const { allWarehouses } = next
    if (!loading && loadingWarehouses && !next.loadingWarehouses) {
      if (allWarehouses.length === 1 && order.warehouse && !order.warehouse.value) {
        const data = allWarehouses[0]
        setInfo({ ...order, warehouse: data, products: [] })
      } else {
        for (let i = 0; i < allWarehouses.length; i++) {
          if (allWarehouses[i].attendant === user.id) {
            let data = allWarehouses[i]
            this.props.setInfo({ ...order, warehouse: data, products: [] })
            break
          }
        }
      }
    }

    const { loadingI, setInventoryList, company } = this.props
    const { inventory } = next

    if (loadingI && !next.loadingI) {
      let items = inventory.map(i => {
        const { inventory, amounts } = i
        const { productPrice, productCompanyId, productActive, productId } = inventory
        const { id } = company

        i.contract = true
        i.prices = []
        i.discountLimit = true

        let setting = {
          checked: false,
          realQuantity: 0,
          subTotal: 0,
          maxDiscount: 0,
          quantity: 0,
          discount: 0,
          sQuantity: 0,
        }

        if (order && order.details) {
          const detail = order.details.find(d => d.product.id == productId)
          if (detail) {
            setting = {
              checked: true,
              realQuantity: detail.quantity,
              quantity: detail.quantity,
              discount: detail.discount,
              sQuantity: 0,
              subTotal: detail.subtotal,
              maxDiscount: detail.quantity * detail.product.price,
            }
          }
        }

        if (!productActive) {
          i.error = 'El producto esta inactivo'
          i.disabled = true
        } else if (productCompanyId === id) {
          i.discountLimit = false
          i.prices.push({
            amount: productPrice,
            minimum: 0,
            maximum: 1000000,
            price: productPrice,
          })
        } else if (amounts.length === 0) {
          i.error = 'No se ha encontrado contrato de transporte para este producto.'
          i.disabled = true
          i.contract = false
        } else {
          amounts.map(a => i.prices.push({ ...a, price: a.amount }))
        }

        return { ...i, ...inventory, ...setting }
      })
      setInventoryList(items)
    }

    const { loadingRoles, getAllClients, getClients } = this.props
    const { getPermission, isAllowed } = next
    if (loadingRoles && !next.loadingRoles) {
      let vendor = 0
      let deliverer = 0

      const canViewAll = isAllowed([clientPermissions.viewAll])

      if (module === 1000 && (!getPermission(1000) || !getPermission(1001))) {
        if (getPermission(1002)) vendor = user.id
        if (getPermission(1003)) deliverer = user.id
      }

      if (module === 2000 && (!getPermission(2000) || !getPermission(2001))) {
        if (getPermission(2002)) vendor = user.id
        if (getPermission(2003)) deliverer = user.id
      }

      if (this.props.module === 11000 || canViewAll) getClients(null, null)
      else getClients(user.id, user.id)
    }

    const { loadingC, loadingCP } = this.props
    const { allClients } = next
    if ((loadingC && !next.loadingC) || (loadingCP && !next.loadingCP)) {
      const clientDefault = allClients.find(c => c.code === '3000CA')
      if (clientDefault && !order.id)
        setInfo({ ...order, client: clientDefault, products: [] })
    }
  }

  render() {
    const { alert, steps } = this.state
    const { loading } = this.props
    return (
      <div>
        <Alert {...alert} />

        {loading ? (
          <Row>
            {[0, 0, 0].map((i, index) => (
              <Col key={index} md={4}>
                <Placeholder />
              </Col>
            ))}
          </Row>
        ) : (
          steps.length > 0 && (
            <Card title={'Orden'}>
              <Row>
                <Col>
                  <div className={'step-progress'}>
                    <StepZilla
                      steps={steps}
                      stepsNavigation={false}
                      dontValidate={true}
                      showNavigation={false}
                    />
                  </div>
                </Col>
              </Row>
            </Card>
          )
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  order: selectGetSingleOrder(state),
  loading: loadingSelector([actionTypes.GET_SINGLE_ORDER])(state),
  loadingWarehouses: loadingSelector([warehouseActionTypes.GET_ALL_WAREHOUSES])(state),
  hasError: hasErrorsSelector([actionTypes.GET_SINGLE_ORDER])(state),
  error: singleErrorSelector([actionTypes.GET_SINGLE_ORDER])(state),
  module: selectCurrentModule(state),
  company: selectSetCurrentCompany(state),
  getPermission: id => getPermission(state, id),
  user: selectCurrentUser(state),
  allWarehouses: selectAllWarehousesForSelect(state),
  currentCompany: selectCurrentCompany(state),
  loadingI: loadingSelector([warehouseActionTypes.GET_INVENTORY_WITH_PRICE])(state),
  inventory: selectInventoryWithPrices(state),
  loadingRoles: loadingSelector([moduleTypes.GET_CURRENT_USER_ROLES])(state),
  allClients: simpleClients(state),
  loadingC: loadingSelector([typsC.GET_ALL_CLIENTS])(state),
  loadingCP: loadingSelector([typsC.GET_CLIENT_POLYGON])(state),
  isAllowed: permissions => isAllowed(state, permissions),
})
const mapDispatchToProps = dispatch => ({
  getOrder: id => dispatch(getSingleOrder(id)),
  setInfo: order => dispatch(setInformationOrder(order)),
  getAllClients: () => dispatch(getAllClients()),
  getDeliverers: () => dispatch(getAllDeliverers()),
  getWarehouses: isKolo => dispatch(getWarehouses(false, isKolo)),
  getWarehousesUser: () => dispatch(getWarehousesUser()),
  setInventoryList: list => dispatch(setInventoryList(list)),
  getInventoryWithPrices: (id, client, reserve) =>
    dispatch(getInventoryWithPrices(id, client.latitude, client.longitude, reserve, 1)),
  getInventory: (id, includeNoExistence) =>
    dispatch(getInventory(id, includeNoExistence, false)),
  getCurrentRoles: module => dispatch(getCurrentUserRolesAction(module)),
  setOrigin: origin => dispatch(setOrigin(origin)),
  getCompanyField: id => dispatch(getCompanyField(id)),
  getPaymentMethods: () => dispatch(getPaymentMethods()),
  getClients: (deliverer, vendor) => {
    let attendant = null
    if (deliverer) attendant = deliverer
    else if (vendor) attendant = vendor

    dispatch(getClientsSimple({ attendant }))
  },
})
export default connect(mapStateToProps, mapDispatchToProps)(OrderCreate)
